import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkoutLinkField"];

  connect() {
    this.updateCheckoutLinkField();
  }

  toggleCheckoutLink() {
    setTimeout(() => {
      this.updateCheckoutLinkField();
    }, 10);
  }

  updateCheckoutLinkField() {
    const checkoutInput = this.element.querySelector(
      'input[name="support_agent_phone[checkout_link_enabled]"]'
    );
    const checkoutEnabled = checkoutInput?.value === "true";

    // Show/hide checkout link field
    if (this.hasCheckoutLinkFieldTarget) {
      if (checkoutEnabled) {
        this.checkoutLinkFieldTarget.classList.remove("hidden");
        this.checkoutLinkFieldTarget.classList.add("mt-2");
      } else {
        this.checkoutLinkFieldTarget.classList.add("hidden");
        this.checkoutLinkFieldTarget.classList.remove("mt-2");
      }
    }
  }
}
